import { render, staticRenderFns } from "./PgcRankItem.vue?vue&type=template&id=6a685ec4&"
import script from "./PgcRankItem.vue?vue&type=script&lang=js&"
export * from "./PgcRankItem.vue?vue&type=script&lang=js&"
import style0 from "./PgcRankItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports